/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React, { useState } from "react";

import styled from "styled-components";

import { ImageBlock } from "src/classes/block/block-types";

interface Props {
  block: ImageBlock;
}
export function EditableCaption({ block }: Props) {
  const captionRef = React.useRef<HTMLInputElement | null>(null);
  const [value, setValue] = useState(block.snapshot.caption || "");

  const save = () => {
    if (value.trim() === "") {
      block.removeCaption();
    } else {
      block.updateCaption(value);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    e.stopPropagation();
    switch (e.code) {
      case "Enter":
      case "Escape":
        e.preventDefault();
        save();
        captionRef.current?.blur();
        break;
    }
  };

  return (
    <InputContainer>
      <ResizeableInput
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value.slice(0, 50))}
        onKeyDown={handleKeyDown}
        onBlur={() => save()}
        maxLength={50}
        autoFocus={!value}
        ref={captionRef}
      />
      <InputClone>{value}&nbsp;</InputClone>
    </InputContainer>
  );
}

const InputContainer = styled.div`
  position: absolute;
  max-width: 80%;
  left: 3px;
  bottom: 3px;
`;

const ResizeableInput = styled.input`
  position: absolute;
  background: rgba(225, 225, 225, 0.85);
  border: 1px solid black;
  font-size: 14px;
  padding-left: 3px;
  padding-right: 3px;
  width: 100%;
  font-family: "IBM Plex Sans", sans-serif;
  white-space: nowrap;
  overflow-x: ellipsis;
`;

const InputClone = styled.span`
  font-size: 14px;
  padding-left: 3px;
  padding-right: 3px;
  width: 100%;
  font-family: "IBM Plex Sans", sans-serif;
  white-space: nowrap;
  word-wrap: break-word;
  visibility: hidden;
  pointer-events: none;
  user-select: none;
`;
